<cs-icon class="tw-text-white tw-h-6 tw-w-6 tw-absolute tw-top-6 tw-right-6" [iconName]="'close'"
    (click)="close()"></cs-icon>


<video class="tw-h-full tw-w-full tw-object-contain" controls="controls" autoplay [src]="data?.url"></video>